if(!customElements.get('custom-collection-product-list')){
    class CollectionProductList extends HTMLElement {

        constructor(){
            super();
            
            this.init();
        }

        init(){
            this.btnColumnSwitch = this.querySelector('.product-view-switch-wrapper');
            if(this.btnColumnSwitch){
                this.btnColumnSwitch.addEventListener('click', this.updateNumColumns.bind(this));
                this.btnColumnSwitch.addEventListener('keydown', e => {
                    if(e.key === 'Enter'){
                        this.updateNumColumns(e);
                    }
                });
            }
        }

        updateNumColumns(){
            this.productCardWrapper = this.querySelectorAll('.product-card__wrapper');

            // toggle between 3 and 4 columns; from any other state (e.g. 6), fall back to 3
            const nextColumn = this.btnColumnSwitch.dataset.column == '3' ? '4' : '3';

            this.productCardWrapper.forEach(item => {
                item.classList.remove('col-xl-2', 'col-xl-3', 'col-xl-4', 'col-6', 'col-12');

                if(nextColumn == '3'){
                    item.classList.add('col-xl-4', 'col-12');
                }else{
                    item.classList.add('col-xl-3', 'col-6');
                }
            });

            this.btnColumnSwitch.setAttribute('data-column', nextColumn);
        }
    }

    customElements.define('custom-collection-product-list', CollectionProductList);
}